import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import { ANALYTICS_SUBJECT_ID_INSTALL_CLOSE } from '../../../../analytics/Events';
import { SecondaryCTAWithAnalytics } from '../../../common/SecondaryCTA';
import { jsx as _jsx } from "react/jsx-runtime";
export default class CloseButton extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "render", () => /*#__PURE__*/_jsx(SecondaryCTAWithAnalytics, {
      actionSubjectId: ANALYTICS_SUBJECT_ID_INSTALL_CLOSE,
      isDisabled: false,
      onClick: this.props.onClick,
      children: "Close"
    }));
  }
}